import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportTimeReporting_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportTimeReporting extends Report<ReportTimeReporting_Settings> {

    public settings    : ReportTimeReporting_Settings

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_TIME_REPORTING
        super(data);

        this.icon        = "isvg-time-reporting"
        this.description = "Tracks reported hours for teams and departments, comparing actual vs. guesstimated time to identify trends and assess consistency."

        this.settings    = new ReportTimeReporting_Settings(data.settings)
    }

    static initFromSavedView(savedView:SavedView): ReportTimeReporting {
        return new ReportTimeReporting(savedView.toReportConfig())
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportTimeReporting_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

}
